import ColorHash from "color-hash";

class ColorGenerator {
  
  static colorHash = null;
  
  static createColorHashIfNeeded(){
    if(ColorGenerator.colorHash){
      return ColorGenerator.colorHash;
    }
    
    ColorGenerator.colorHash = new ColorHash({
      lightness: 0.6,
      hue: [
        {min: 30, max: 90},
        {min: 180, max: 210},
        {min: 270, max: 285}
      ],
      saturation: 0.7,
      hash: ColorGenerator.hashString,
    });
  }
  
  static hashString(str){
    var hash = 0;
    if (str.length === 0) {
      return hash;
    }
    for (var i = 0; i < str.length; i++) {
      var char = str.charCodeAt(i);
      hash = ((hash<<5)-hash)+char;
      hash = hash & hash; // Convert to 32bit integer
    }
    
    //For some reason the color hashing algorithm doesn't like big negative numbers.
    //Just a fast and semi random way to tweak them.
    if(hash < 0){
      hash = Math.abs(hash << 5);
    }
    return hash;
  }
  
  static generateColorFromId(id) {
    ColorGenerator.createColorHashIfNeeded();
    
    return ColorGenerator.colorHash.hex(id);
  }
}



export default ColorGenerator;
